import { dutchAmounts } from "./dutch-amount.service";
import { leg } from "./leg.service";
import { ticketRequest } from "./ticket-request.service";
import { wager } from "./wager.service";
import { calcBets } from "./wagercosting.service";
import _ from 'lodash';

export class dutchWagersService {
  constructor() {}

  buildDutchWagers(
    dutch: number,
    legs: any,
    modifier: string,
    pool: any,
    userInput: any,
    matrix: any,
    events: any[],
    selectedRace: any,
    selectedEvent: any,
    maxWagerTotal: number,
    isBlockJurisdiction: boolean,
    isBlockJurisdictionMsg: string,
    toRemoveTickets?: any
  ): any {
    const runners: any[] = [];
    const max = legs.length - 1;
    const wagerArray: any[] = [];

    function helper(arr: any[], i: number): void {
      for (let j = 0; j < legs[i].length; j++) {
        const a = [...arr];
        a.push(legs[i][j]);

        if (i === max) {
          if (pool.Legs > 1) {
            if (a[0] !== a[1]) {
              runners.push(a);
            }
          } else {
            runners.push(a);
          }
        } else {
          helper(a, i + 1);
        }
      }
    }

    if (legs.length === pool.Legs * pool.PoolRaces) {
      helper([], 0);
    }

    if (toRemoveTickets !== undefined) {
      let rbwIndexsToRemove = [];
      for(let rc = 0; rc < toRemoveTickets.length; rc++){
          for(let rbw = 0; rbw < runners.length; rbw++){
              if(JSON.stringify(toRemoveTickets[rc]) == JSON.stringify(runners[rbw])){
                rbwIndexsToRemove.push(rbw);
              }
          }
      }
      rbwIndexsToRemove.sort(function(a, b){return b-a});
      for(let rbwR = 0; rbwR < rbwIndexsToRemove.length; rbwR++){
        runners.splice(rbwIndexsToRemove[rbwR], 1);
      }
    }

    const dutchHolder = new dutchAmounts(runners, pool, userInput);
    let dutchAmountHolder: any;

    dutchHolder.initBaseParams(matrix);

    if (dutch == 1) {
      dutchAmountHolder = dutchHolder.calcAmountByBaseAmount(userInput, matrix);
    }
    else
    {
      dutchAmountHolder = dutchHolder.calcAmountByBasePayout(userInput, matrix);
    }

    const event = _.find(events, { id: matrix.EventId });
    for (let i = 0; i < runners.length; i++) {
      const tempLeg = [];
      const runnersList = [];
      for (let j = 0; j < runners[i].length; j++) {
        if (selectedRace?.Runners) {
          runnersList.push(selectedRace.Runners[runners[i][j] - 1]);
          tempLeg.push(new leg(false, [runners[i][j]]));
        }
      }

      let thisRunnerCombo = [];
      if (pool.PoolRaces * pool.Legs === 1) {
        thisRunnerCombo = [[runners[i]]];
      } else {
        thisRunnerCombo = [[runners[i][0]], [runners[i][1]]];
      }

      const wagerTemp = new wager(
        matrix.RaceId,
        pool.PoolId,
        dutchAmountHolder[i][0],
        modifier,
        tempLeg,
        calcBets(
          modifier,
          pool.Legs,
          pool.Combine,
          thisRunnerCombo,
          dutchAmountHolder[i][0],
          maxWagerTotal,
          // pool.Maximum,
          pool.Unordered,
          pool.PoolRaces
        ),
        maxWagerTotal
      );

      if (
        wagerTemp.getError(
          event,
          event?.ToteResponse?.EventDetail?.Races[matrix.RaceId - 1],
          pool,
          thisRunnerCombo,
          isBlockJurisdiction,
          isBlockJurisdictionMsg
        ) === -1
      ) {
        wagerTemp.Bets = 0;
      } else {
        wagerTemp.Error = null;
      }
      wagerTemp.Legs = tempLeg;

      wagerArray.push(wagerTemp);
    }

    const DutchProjections = {
      ProjectedMaxROI: dutchHolder.calcROI(dutchHolder.MaxPayout),
      ProjectedMinROI: dutchHolder.calcROI(dutchHolder.MinPayout),
    };

    return new ticketRequest(
      selectedEvent?.ToteResponse?.RunId,
      matrix.EventId,
      matrix.RaceId,
      wagerArray,
      dutch,
      DutchProjections
    );
  }
}
